export enum FormularzLabels {
    CzasTeraz = 'Czas teraz',
    CzasDostawy = 'Czas dostawy',
    DoZaplaty = 'Do zapłaty',
    TerenDostawy = 'Teren dostawy',
    Adres = 'Twój adres', //'Adres dostawy', //'Adres',
    Telefon = 'Twój telefon',//'Telefon',
    NIP = 'NIP',
    Date = "Data",
    Email = 'e-mail',
}

export enum FormikFieldNames {
    Telefon = 'phone',
    Adres = 'address',
    Date = 'data',
    NIP = 'NIP',
    Email = 'email',
}